import { API, Endpoints, Status, TagsAPI } from "@brg/api"
import { useEffect, useState } from "react"

export const useGetUserStatusTags = (accountId: string): [Status[], boolean] => {
    const [data, setData] = useState<Status[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const fetch = async(id: string) => {
        setIsLoading(true)
        await API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url(`/api/TagsResponsibility/GetUserInfo`)
        .addQuery('accountId', id)
        .get()
        .send()
        .then((response) => {
            if (response.ok) {
                return response.json()
            }
        })
        .then((data) => {
            setData(data)
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        fetch(accountId)
    }, [accountId])

    return [data, isLoading]

}import { API, Endpoints, Status, TagsAPI } from "@brg/api"
import { useEffect, useState } from "react"

export const useGetUserStatusTags = (accountId: string): [Status[], boolean] => {
    const [data, setData] = useState<Status[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const fetch = async(id: string) => {
        setIsLoading(true)
        await API.request()
        .endpoint(Endpoints.tagsMnePw)
        .url(`/api/TagsResponsibility/GetUserInfo`)
        .addQuery('accountId', id)
        .get()
        .send()
        .then((response) => {
            if (response.ok) {
                return response.json()
            }
        })
        .then((data) => {
            setData(data)
        })
        .finally(() => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        fetch(accountId)
    }, [accountId])

    return [data, isLoading]

}